import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {fetchData} from '../../Utils/Server';
import Endpoints from '../../Constants/Endpoints';
import PageLayout from '../Layout/PageLayout';
import {Card, CardTitleBar, CardBody, Chip, Spinner, EmptyState} from '../UI';
import {tokens} from '../../theme/tokens';

export default function RoleDetails() {
    const {id} = useParams();
    const [role, setRole] = useState(null);

    useEffect(() => {
        fetchData(Endpoints.LIST_ROLES)
            .then((res) => res.json())
            .then((res) => {
                const found = (res.roles || []).find((r) => r.name === id);
                setRole(found);
            });
    }, [id]);

    if (!role) {
        return (
            <PageLayout title="Role">
                <Spinner center label="Loading…"/>
            </PageLayout>
        );
    }

    return (
        <PageLayout title={role.name}>
            <Card padded={false}>
                <CardTitleBar title="Permissions"/>
                <CardBody>
                    {role.permissions.length === 0 ? (
                        <EmptyState
                            title="No permissions"
                            description="This role has no permissions assigned."
                        />
                    ) : (
                        <div style={{display: 'flex', flexWrap: 'wrap', gap: tokens.spacing[2]}}>
                            {role.permissions.map((p) => (
                                <Chip key={p} style={{fontFamily: tokens.typography.fonts.mono}}>{p}</Chip>
                            ))}
                        </div>
                    )}
                </CardBody>
            </Card>
        </PageLayout>
    );
}
